module.exports = __webpack_public_path__ + "img/product11.d30c99a4.png";